import { httpsCallable } from 'firebase/functions';
import { CloudFunctions, FirebaseAuth } from '../utils/firebase/firebase';
import { BASE_URL } from '../constants/AppUrl';


// export const fetchAllAttachments = async (uid) => {
//   try {
//     const getAllAttachmentsData = httpsCallable(
//       CloudFunctions,
//       'getAllAttachmentsData'
//     );

//     const response = await getAllAttachmentsData({
//       uid,
//     });
//     console.log('response: ', response);

//     if (response.data.status) {
//       return response.data;
//     } else {
//       return response;
//     }
//   } catch (e) {
//     console.log(e);
//     throw e;
//   }
// };

export const fetchAllAttachmentsByUser = async (uid, typeOfUser) => {
  try {
    const getAllAttachmentsByUser = httpsCallable(
      CloudFunctions,
      'getAllAttachmentsByUser'
    );

    const response = await getAllAttachmentsByUser({
      uid,
      typeOfUser,
    });

    if (response?.data?.status) {
      return response?.data;
    } else {
      return response;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const removeGoalFromDocument = async (
  studentId,
  docType,
  docId,
  goalSummaryId,
  uid
) => {
  try {
    const currentUser = FirebaseAuth?.currentUser;

    if (!currentUser) {
      throw new Error('User is not authenticated');
    }

    const token = await currentUser.getIdToken();

    const response = await fetch(
      `${BASE_URL}/removeGoalFromDocument`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          studentId,
          docType,
          docId,
          goalSummaryId,
          uid,
        }),
      }
    );

    const data = await response.json();

    if (response.ok && data?.status) {
      return data;
    } else {
      throw new Error(data?.message || 'Failed to remove goal');
    }
  } catch (e) {
    console.error('Error in removeGoalFromDocument:', e);
    throw e;
  }
};

export const fetchAllReportsByUser = async (uid, typeOfUser) => {
  try {
    const getAllReportsByUser = httpsCallable(
      CloudFunctions,
      'getAllReportsByUser'
    );

    const response = await getAllReportsByUser({
      uid,
      typeOfUser,
    });

    if (response?.data?.status) {
      return response?.data;
    } else {
      return response;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const migrateCustomizedDataEntrySectionsToVault = async (schoolId) => {
  try {
    console.log(
      'migrateCustomizedDataEntrySectionsToVault API called with schoolId:',
      schoolId
    );

    const migrateCustomizedDataEntrySectionsToVault = httpsCallable(
      CloudFunctions,
      'migrateCustomizedDataEntrySectionsToVault'
    );

    const response = await migrateCustomizedDataEntrySectionsToVault({
      schoolId,
    });

    console.log('Migration response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error calling migration API:', error);
    throw error;
  }
};

export const addActivityLog = async (
  collectionName,
  studentId,
  subCollection,
  documentId,
  activityData
) => {
  try {
    const addActivityLogFunction = httpsCallable(
      CloudFunctions,
      'addActivityLog'
    );

    const response = await addActivityLogFunction({
      collectionName,
      studentId,
      subCollection,
      documentId,
      activityData,
    });

    if (response.data.status) {
      return {
        success: true,
        message: response.data.message,
      };
    } else {
      console.warn('Failed to add activity log:', response.data.message);
      return {
        success: false,
        message: response.data.message,
      };
    }
  } catch (error) {
    console.error('Error adding activity log:', error);
    throw error;
  }
};